import { string, array, object } from 'yup';

export const possessionsValidation = object().shape({
  possessions: array().of(string()).min(1, 'At least one possession is required').required('At least one possession is required'),
});
